$(function(){

	$("#header").hide();
	$("#header").addClass('hidden');
	$("#header").show();

	var swiperReachedEnd = false;

	//-------Activate Swiper-------
	const swiper = new Swiper('.swiper-container', {
		direction: 'horizontal',
		keyboard: true,
		mousewheel: {
			releaseOnEdges: false,
			forceToAxis: true,
		},
		pagination: {
	    	el: '.swiper-pagination',
	    	clickable: true,
		},
		lazy: {
			loadPrevNext: true,
		},
	 navigation: {
	    nextEl: '.swiper-next'
	  },
			speed: 1000,

		 // Responsive breakpoint
		  breakpoints: {
		    // when window width is >= 768px
		    768: {
		    	direction: 'vertical',
				mousewheel: {
					releaseOnEdges: false,
					forceToAxis: true,
				},
				keyboard: true,
				pagination: {
			    	el: '.swiper-pagination',
			    	clickable: true,
				},
				lazy: {
					loadPrevNext: true,
				},
				speed: 1000,
		    },
		  }
	});
	callAnimations(0);

	var delayedHeaderClose;

	swiper.on('slidePrevTransitionStart', function () {
		if(window.matchMedia("(min-width: 768px)").matches){
			swiperReachedEnd = false;
	  		$("#header").removeClass('hidden');
			headerToggle = true;
			
			clearTimeout(delayedHeaderClose);
			delayedHeaderClose = setTimeout(function(){
		    	$("#header").addClass('hidden');
				headerToggle = false;
			}, 1500);
		}
		
		if($(".swiper-slide-active").hasClass("change-scroll--white"))
	  {
			$(".scroll").addClass("scroll--white");  
	  }
	  else
	  {
			$(".scroll").removeClass("scroll--white");  
	  }
	  
	  if($(".swiper-slide-active").hasClass("change-menu--white"))
	  {
		  $("body").addClass("kv--dark");
	  }
	  else
	  {
		   $("body").removeClass("kv--dark");
	  }
	});

	swiper.on('slideNextTransitionStart', function () {
	  if(window.matchMedia("(min-width: 768px)").matches){
	  	$("#header").addClass('hidden');
		headerToggle = false;
		swiperReachedEnd = false;
		clearTimeout(delayedHeaderClose);
	  }
	  
	  if($(".swiper-slide-active").hasClass("change-scroll--white"))
	  {
			$(".scroll").addClass("scroll--white");  
	  }
	  else
	  {
			$(".scroll").removeClass("scroll--white");  
	  }
	  
	  if($(".swiper-slide-active").hasClass("change-menu--white"))
	  {
		  $("body").addClass("kv--dark");
	  }
	  else
	  {
		   $("body").removeClass("kv--dark");
	  }
	});
	
	swiper.on('slideChangeTransitionEnd', function () {
	  resetAnimations();
	  callAnimations(swiper.activeIndex);
	  if(swiper.isEnd && window.matchMedia("(min-width: 768px)").matches){
	  	swiperReachedEnd = true;
	  	swiper.mousewheel.disable();
	  }
	});

	$(window).on('scroll', function() {
		if(window.pageYOffset==0 && window.matchMedia("(min-width: 768px)").matches){
			swiper.mousewheel.enable();
		}
	});

	//------- Hide PC header after hover on pagetop when in KV-------
	$("#header").mouseleave(function(){
		if(window.pageYOffset==0){
	  		$("#header").addClass('hidden');
			headerToggle = false;
		}
	});


	//-------Fix for locking up on last slide--------
	window.addEventListener('wheel', function(event){
		if (event.deltaY < 0){
			if(window.pageYOffset==0 && window.matchMedia("(min-width: 768px)").matches){
	  			swiper.mousewheel.enable();
	    	}
	 	}
		else if (event.deltaY > 0)
		{
			if(swiperReachedEnd && window.matchMedia("(min-width: 768px)").matches){
	  			swiper.mousewheel.disable();
	  		}
		}
	});



	function callAnimations(currentSlide){
		var currentSlide = $(".swiper-slide").eq(currentSlide);

		if(window.matchMedia("(min-width: 768px)").matches){
			var getAnimations = currentSlide.find(".anim, .anim-pc");
		}
		else{
			var getAnimations = currentSlide.find(".anim, .anim-sp");
		}
		var delayTimer = 0;
		for(let i = 0; i < getAnimations.length; i++){
			setTimeout(function() {
		    	getAnimations.eq(i).addClass("is-animated");
			}, delayTimer);
			// delayTimer+=500;
		}

	}

	function resetAnimations(){
		$(".anim, .anim-pc, .anim-sp").removeClass("is-animated");
	}


	//Return SP menu button to black when scroll below KV
	$('#sp-KV-under').waypoint(function(direction){
	    var activePoint = $(this.element);
	    if (direction === 'down') { //scroll down
	        $("body").removeClass('kv--dark');
	        console.log("A");
	    }
	    else{ //scroll up
	    	console.log("B");
	        if($(".swiper-slide-active").hasClass("change-menu--white"))
			  {
					$("body").addClass('kv--dark');
			  }
	    }
	},{offset : '0%'});


});